import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { SearchErrorMessageWrapper } from '../search-error-message';
import { Results } from './results';
export const SearchResultsWrapper = inject('searchResults', 'context', 'uiPage', 'multiItem')(observer(({
  searchResults,
  context,
  uiPage,
  multiItem
}) => {
  if (!uiPage || !searchResults) return null;
  const {
    searchCriteria
  } = searchResults;
  const similarDestinationProps = (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) ? null : {
    inputs: {
      collectionId: 'similar_destinations'
    },
    pageContext: {
      propertySearch: searchCriteria,
      context
    }
  };
  const renderErrorMessage = () => (multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath()) ? React.createElement(SearchErrorMessageWrapper, null) : React.createElement(React.Fragment, null);
  return React.createElement(Results, {
    errorMessage: renderErrorMessage(),
    similarDestinationProps: similarDestinationProps
  });
}));